var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTouchpointAndCustomerCareCardsCourierDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3498.000000, -1509.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-touchpoint-and-customer-care/Cards-Courier-Delivery",
    transform: "translate(3498.000000, 1509.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7,8 C30.9,8 32,9.1 31.9,10.3 L31.9,10.3 L31.9,22.7 C31.9,23.9 30.9,25 29.6,25 L29.6,25 L9.3,25 C8.2,25 7.3,24.2 7,23 L7,23 L9.4,15.7 C9.6,16 9.9,16.2 10.2,16.2 L10.2,16.2 L14.5,16.2 C15,16.2 15.4,15.8 15.4,15.3 L15.4,15.3 L15.4,12.8 C15.4,12.3 15,11.9 14.5,11.9 L14.5,11.9 L10.8,11.9 L12.1,8 Z M13.2,19.8 L9.3,19.8 L9.3,22.1 L13.2,22.1 L13.2,19.8 Z M18.7,19.8 L14.8,19.8 L14.8,22.1 L18.7,22.1 L18.7,19.8 Z M24.2,19.8 L20.3,19.8 L20.3,22.1 L24.2,22.1 L24.2,19.8 Z M29.7,19.8 L25.8,19.8 L25.8,22.1 L29.7,22.1 L29.7,19.8 Z M6.7,18 L5.7,20.7 C4.7,20.2 4,19.2 4,18 L4,18 L6.7,18 Z M8.3,13 L7.3,16 L5,16 C3.3,16 2,14.7 2,13 L2,13 L8.3,13 Z M10,8 L9,11 L3,11 C1.3,11 0,9.7 0,8 L0,8 L10,8 Z",
    id: 300
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTouchpointAndCustomerCareCardsCourierDelivery);
export default __webpack_public_path__ + "static/media/bank-touchpoint-and-customer-care-cards-courier-delivery.e36aa9e3.svg";
export { ForwardRef as ReactComponent };